<template>
    <div class="hero">
        <img class="hero-image" src="/img/hero-krispy-mobile.webp"
            fetchpriority="high"
            srcset="/img/hero-krispy-mobile.webp 768w, /img/hero-krispy-2560.webp 2560w, /img/hero-krispy-4096.webp 4096w" rel="preload" as="image"
            alt="Couple moving boxes from apartment" />
        <div class="container">
            <div class="top-hero" v-rellax="{ speed: 2 }">
                <h1>Rent rooms, flats and houses easier and quicker</h1>
            </div>
            <BottomHero class="over-desktop-only" :ad-categories="adCategories" v-rellax="{ speed: 2 }" />
            <BottomHero class="less-desktop-only" :ad-categories="adCategories" />
            <a href="#app-presentation" class="scroll-icon"></a>
        </div>
    </div>
</template>

<script>
import BottomHero from './partials/BottomHero.vue';

export default {
    components: {
        BottomHero,
    },
    props: {
        adCategories: {
            type: Array,
            required: true,
        },
    },
};
</script>
